import { useEffect, useState } from "react";
import Header from "../common/Header";
import { Loading } from "../Loading";
import Select from "@material-ui/core/Select";
import { useHistory } from "react-router-dom";
import { useUserStores } from "../../shared/hooks/useUserStores";
import {
  getUserStoreIdFromLocalStorage,
  getUserStoreNameFromLocalStorage,
  getUserStoresFromLocalStorage,
  setUserStoreIdToLocalStorage,
  setUserStoreNameToLocalStorage,
} from "../../helpers/localStorageHelper";

export function Stores() {
  const history = useHistory();
  const { data, isLoading, refetch } = useUserStores();

  useEffect(() => {
    refetch();
  }, [refetch]);

  const [product, setProduct] = useState(getUserStoreIdFromLocalStorage());

  const handleStoreChange = (event: any) => {
    const nextStoreId = String(event.target.value || "");
    const userStores = data ?? getUserStoresFromLocalStorage();
    const selectedStore = userStores.find((store: any) => store.storeId === nextStoreId);

    setProduct(nextStoreId);
    setUserStoreIdToLocalStorage(nextStoreId);

    if (selectedStore) {
      setUserStoreNameToLocalStorage(selectedStore.storeName);
    }

    history.push("/");
  };

  if (isLoading) {
    return <Loading />;
  }
  // const headers = ["Time", "Group", "Product", "Qty"];
  // const tableBody = ["productionTime", "group", "product", "actualQuantity"];

  var userStoreName = getUserStoreNameFromLocalStorage();
  const headerObject = {
    title: `SOUL ORIGIN (${userStoreName})`,
    subTitle: "My Stores",
  };

  const userStores = (data ?? getUserStoresFromLocalStorage()) as any[];
  const activeUserStores = userStores.filter((store: any) => store.isActive !== false);

  return (
    <div className="MuiInputBase-root MuiInput-root col-md-6 lg-6">
      <div className="row ml-lg-3 mt-md-3 text-left">
        <Header {...headerObject} />
        <div className="row m-lg-3">
          <Select
            native
            value={product}
            onChange={handleStoreChange}
            label="Product"
            inputProps={{
              name: "product",
              id: "outlined-product",
            }}
          >
            <option aria-label="None" value="">
              Change Store
            </option>

            {activeUserStores.map((item: any, index: any) => (
              <option key={index} value={item.storeId}>
                {item.storeName} - {item.storeId}
              </option>
            ))}
          </Select>
        </div>
      </div>
    </div>
  );
}
